import _isNaN from "lodash/isNaN";
import numeral from 'numeral';

/**
 * Utility module for number related helper functions.
 *
 */
export default {
  /**
   * Constrains the number between the min and max values.
   *
   * @param {number} num The number to be constrained to.
   * @param {number} min The minimum limit
   * @param {number} max The maximum limit.
   *
   * @returns {number}
   */
  constrain: function constrain(num, min, max) {
    return Math.min(Math.max(num, min), max);
  },
  formatCurrency: function formatCurrency(value, includeCents) {
    var input = value;
    var formatString = '$0,0';
    if (includeCents) formatString += '.00';
    if (_isNaN(input)) input = 0;
    return numeral(input).format(formatString);
  },
  formatPercent: function formatPercent(input, formatterStr) {
    return numeral(input).format(formatterStr || '0.0[00]%');
  },
  value: function value(formattedInput) {
    return numeral(formattedInput).value();
  }
};